import { CampaignData } from 'interface/WizardV3';

export const calculateFrom2FADate = ({
  smsCampaignData,
}: {
  smsCampaignData: CampaignData;
}) => {
  if (
    smsCampaignData?.submission2faDateMs &&
    smsCampaignData?.latest2faDateMs
  ) {
    const MS_IN_A_DAY = 24 * 60 * 60 * 1000;
    const submission2faDateMs = new Date(smsCampaignData?.submission2faDateMs);
    const latest2faDateMs = new Date(smsCampaignData?.latest2faDateMs);
    const dateTime = new Date();
    const deltaSubmission2faDate =
      dateTime.getTime() - submission2faDateMs.getTime();
    const deltaLatest2faDate = dateTime.getTime() - latest2faDateMs.getTime();
    const has7DaysPassed = deltaLatest2faDate > 7 * MS_IN_A_DAY;
    const has30DaysPassed = deltaSubmission2faDate > 30 * MS_IN_A_DAY;
    const email2faExpiresIn = 7 - deltaLatest2faDate / MS_IN_A_DAY;
    const verificationExpiresIn = 30 - deltaSubmission2faDate / MS_IN_A_DAY;
    const resubmissionExpiresIn = 75 - deltaSubmission2faDate / MS_IN_A_DAY;
    return {
      email2faSent: true,
      has7DaysPassed,
      has30DaysPassed,
      email2faExpiresIn,
      verificationExpiresIn,
      resubmissionExpiresIn,
    };
  }
  return {
    email2faSent: false,
    has7DaysPassed: false,
    has30DaysPassed: false,
    resendVerificationEmailIn: 0,
    verificationExpiresIn: 0,
    resubmissionExpiresIn: 0,
  };
};
